<template>
	<div>
		<firstsceenimage :imgobj='banner' title="C2M智能定制解决方案" subtitle="C2m intelligent customization solution"
			button="white" stylemode="white">
			<button
				style=" font-size: 13px; border: 1px solid #E8C570;color: black; margin-top: 25px;line-height: 32px;  width: 80px; height: 32px;background-color: #E8C570;">
				预约演示
			</button>
		</firstsceenimage>

		<div v-if="isShowNavAD" ref="customimg1ref"
			style="margin-top: -220px;width: 100%;text-align: center;padding: 80px;">
			<div style=" color:white; font-size: 45px;font-weight: bold;">AI脚型数据扫描+鞋楦匹配算法+C2M高级定制</div>
			<div style="align-items: center;text-align: center;width: 100%;margin-top: 30px;">
				<transition name="adfadex2">
					<img v-if="customimg1show" style=" height: 400px; " src="../../static/c1.png" />
				</transition>
				<transition name="adfadex3">
					<img v-if="customimg1show" style=" height: 400px; margin-left: -210px;margin-top: -5px;"
						src="../../static/c2.png" />
				</transition>
				<transition name="adfadex4">
					<img v-if="customimg1show" style=" height: 400px; margin-left: -210px;margin-top: -10px;"
						src="../../static/c3.png" />
				</transition>
				<transition name="adfadex5">
					<img v-if="customimg1show" style=" height: 400px; margin-left: -210px;margin-top: -15px;"
						src="../../static/c4.png" />
				</transition>
				<div v-if="!customimg1show" style="height: 400px;"> </div>
			</div>
		</div>

		<div ref="customimg2ref">
			<adword title="AI脚型测量仪微米级数据测量"
				subtitle="星链数据3D扫描仪是一种集光学图像，机械传动，电子控制，计算机工程，数据处理运算于一体的高效率高精度的激光3D测量仪器，采用红外激光重建技术及多组传感器多方位同步工作的方式，可在几秒内快速准确的获取足部三维数据及尺寸数据。"
				slotheight="462">
				<div class=" flexcenter" style="margin-top: 30px;">

					<transition name="adfadey1">
						<div v-if="customimg2show"
							style="position: relative;width: 273px;height:373px; overflow: hidden;">
							<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
								<div style="margin-top: 200px;width: 220px;">
									<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
										单脚测量扫描仪
									</div>
									<div class="line-clamp5" style="margin-top: 20px;">
										立式单脚测量仪
										＜1.5mm的浮动误差
										适用于门店获客
									</div>
								</div>

							</div>
							<img style="height: 373px;z-index: 1;" src="../../static/单脚测量扫描仪.png">
						</div>
					</transition>
					<div v-if="!customimg2show" style="position: relative;width: 273px;height:373px; overflow: hidden;">
					</div>
					<div style="width: 10px;height: 1px;"></div>

					<transition name="adfadey1">
						<div v-if="customimg3show"
							style="position: relative;width: 273px;height:373px; overflow: hidden;">
							<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
								<div style="margin-top: 200px;width: 220px;">
									<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
										便携式脚型扫描仪
									</div>
									<div class="line-clamp5" style="margin-top: 20px;">
										旅行箱便携体验
										＜2mm的浮动误差
										上门测量首选
									</div>
								</div>

							</div>
							<img style="height: 373px;z-index: 1;" src="../../static/便携式脚型扫描仪.png">
						</div>
					</transition>
					<div v-if="!customimg3show" style="position: relative;width: 273px;height:373px; overflow: hidden;">
					</div>
					<div style="width: 10px;height: 1px;"></div>
					<transition name="adfadey1">
						<div v-if="customimg4show"
							style="position: relative;width: 273px;height:373px; overflow: hidden;">
							<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
								<div style="margin-top: 200px;width: 220px;">
									<div class="line-clamp1"
										style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
										双脚测量脚型扫描仪
									</div>
									<div class="line-clamp5" style="margin-top: 20px;">
										立式双脚测量仪
										一次性快捷测量
										适用于门店获客
									</div>
								</div>

							</div>
							<img style="height: 373px;z-index: 1;" src="../../static/双脚测量脚型扫描仪.png">
						</div>
					</transition>

					<div v-if="!customimg4show" style="position: relative;width: 273px;height:373px; overflow: hidden;">
					</div>
					<div style="width: 10px;height: 1px;"></div>
					<transition name="adfadey1">
						<div v-if="customimg5show"
							style="position: relative;width: 273px;height:373px; overflow: hidden;">
							<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
								<div style="margin-top: 200px;width: 220px;">
									<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
										手机外接脚型扫描仪
									</div>
									<div class="line-clamp5" style="margin-top: 20px;">
										摆脱场景束缚
										随时随地精准测量
										手机就是一台扫描仪
									</div>
								</div>

							</div>
							<img style="height: 373px;z-index: 1;" src="../../static/手机外接脚型扫描仪.png">
						</div>
					</transition>
					<div v-if="!customimg5show" style="position: relative;width: 273px;height:373px; overflow: hidden;">
					</div>
				</div>
			</adword>
		</div>

		<Adbigwordbutton :pagetop="scrolltop" title="脚型报告智能推荐鞋款" subtitle="56项脚型数据智能分析，为顾客精准定位最适合的鞋履款式等。" :imgurl="img2"
			stylemode="white" hidemb="true">
		</Adbigwordbutton>

		<div ref="customcountref">
			<adword title="深度自研脚楦匹配算法"
				subtitle="依托星链300万脚型数据，基于谷歌TensorFlow人工智能学习系统，深度自研顾客脚型与鞋楦的匹配算法，让每双脚拥有最适合它的鞋楦，做出最适合该脚型的鞋子。顾客只需进行简单的脚型测量，即可自动输出最适合的鞋款。"
				slotheight="303">
				<div class="flexcenter"
					style="margin-top: 50px; margin-left: auto;margin-right: auto;">
					
					<div style="margin: 0px 30px 10px 30px;">

						<div style="font-weight: bold;color: #263E8B;font-size: 26px;">
							<number :animationPaused="customcountshow" ref="number1" :from="0" :to="300"
								:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" /> 万
						</div>
						<div style="color: color: #999999;">脚模数据</div>
					</div>
					<div
						style="width: 1px;height: 83px;box-shadow: 1px 0px 0px 1px #FFFFFF;opacity: 1;border: 1px solid #EAEAEA;">
					</div>
					<div style="margin: 0px 30px 10px 30px;">
						<div style="font-weight: bold;color: #263E8B;font-size: 26px;">
							<number :animationPaused="customcountshow" ref="number2" :from="0" :to="16"
								:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" />项
						</div>
						<div style="color: color: #999999;">算法核心专利</div>
					</div>
					<div
						style="width: 1px;height: 83px;box-shadow: 1px 0px 0px 1px #FFFFFF;opacity: 1;border: 1px solid #EAEAEA;">
					</div>

					<div style="margin: 0px 30px 10px 30px;">
						<div style="font-weight: bold;color: #263E8B;font-size: 26px;">
							<number :animationPaused="customcountshow" ref="number3" :from="0" :to="99.8"
								:format="theFormat2" :duration="2" :delay="0" easing="Power1.easeOut" />%
						</div>
						<div style="color: color: #999999;">首次穿着好评</div>
					</div>
					<div
						style="width: 1px;height: 83px;box-shadow: 1px 0px 0px 1px #FFFFFF;opacity: 1;border: 1px solid #EAEAEA;">
					</div>

					<div style="margin: 0px 30px 10px 30px;">
						<div style="font-weight: bold;color: #263E8B;font-size: 26px;">

							<number :animationPaused="customcountshow" ref="number4" :from="0" :to="1000"
								:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" />+
						</div>
						<div style="color: color: #999999;">门店应用</div>
					</div>
				</div>
			</adword>
		</div>
		<adword title="C2M智能定制" :backimg="img3">
			<div style="height: 500px;"></div>
		</adword>

		<div v-if="isShowNavAD" ref="customimgLCref">
			<adword title="定制全流程">
				<!-- position: relative; -->
				<div style="height: 247px">
					<!--  position:absolute; -->
					<div style="text-align: left;z-index: 0;  padding-top:120px; ">
						<div>
							<img v-if="customimgLCShow" :class="[customimgLCShow?'adfadew3':'']"
								style="margin-left: 15%; width: 75%;height: 17px;" src="../../static/轴承ico3.png">
						</div>

					</div>

					<div style="z-index: 1;margin-top: -135px;">
						<transition name="adfadex2">
							<img v-if="customimgLCShow" style="height: 247px;" src="../../static/测量脚型ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="customimgLCShow" style="margin-left: 7%;height: 247px;"
								src="../../static/选款下单ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="customimgLCShow" style="margin-left: 7%;;height: 247px;"
								src="../../static/鞋楦转换ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="customimgLCShow" style="margin-left: 7%;;height: 247px;"
								src="../../static/柔性生产ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="customimgLCShow" style="margin-left: 7%;;height: 247px;"
								src="../../static/成品试穿ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="customimgLCShow" style="margin-left: 7%;;height: 247px;"
								src="../../static/售后服务2ico.png" />
						</transition>
					</div>

				</div>
			</adword>
		</div>
	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import Adbigwordbutton from '../../components/adBigWordButton.vue'
	import adword from '../../components/adword.vue'
	import banner from '../../static/组 615.png'
	import img2 from '../../static/脚型报告智能推荐鞋款.png'
	import img3 from '../../static/C2M智能定制.png'

	// import video from '../../assets/video/2.mp4'

	export default {
		name: 'Custom',
		components: {
			firstsceenimage,
			adword,
			Adbigwordbutton,
			// advideo,
		},
		data() {
			return {
				banner: banner,
				img2: img2,
				img3: img3,
				scrolltop: 0,
				vscrolltop: 9999,
				customimg1show: false,
				customimg1top: 9999,
				customimg2show: false,
				customimg2top: 9999,
				customimg3show: false,
				customimg4show: false,
				customimg5show: false,

				customcounttop: 9999,
				customcountshow: true,

				customimgLCtop: 99999,
				customimgLCShow: false,

				isShowNavAD: false,
			}
		},
		mounted() {
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			} else {
				this.isShowNavAD = true
			}


			var _this = this
			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件



			setTimeout(() => {
			
				_this.customimg2top = this.$refs.customimg2ref.offsetTop
				_this.customcounttop = this.$refs.customcountref.offsetTop
					_this.customimg1top = this.$refs.customimg1ref.offsetTop
				_this.customimgLCtop = this.$refs.customimgLCref.offsetTop

			}, 200);


		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示1
				if (!this.customimg1show) {
					if (this.vscrolltop > this.customimg1top) {
						this.customimg1show = true;
					}
				}
				//显示2
				if (!this.customimg2show) {
					if (this.vscrolltop > this.customimg2top) {
						_this.customimg2show = true;

						setTimeout(() => {
							_this.customimg3show = true
						}, 200);
						setTimeout(() => {
							_this.customimg4show = true
						}, 400);
						setTimeout(() => {
							_this.customimg5show = true
						}, 800);
					}
				}
				// 数字
				if (this.customcountshow) {
					if (this.vscrolltop > this.customcounttop - 100) {
						this.customcountshow = false;

						this.playAnimation();
					}
				}
				//流程
				if (!this.customimgLCShow) {
					if (this.vscrolltop > this.customimgLCtop - 100) {
						this.customimgLCShow = true;

					}
				}

			},
			theFormat(number) {
				return number.toFixed(0);
			},
			theFormat2(number) {
				return number.toFixed(1);
			},

			completed() {
				console.log('Animation ends!');
			},
			playAnimation() {
				this.$refs.number1.play()
				this.$refs.number2.play()
				this.$refs.number3.play()
				this.$refs.number4.play()
			},


		},

	}
</script>

<style>
	.adfadew3 {

		animation-name: adfadew3d;
		animation-duration: 1s;
	}

	@keyframes adfadew3d {
		0% {
			opacity: 0;
			width: 85%;
		}


		100% {
			opacity: 1;
			width: 75%;
		}
	}
</style>
